<template>
  <div v-if="progress" class="leftbox" style="overflow-y: hidden !important; margin-top: 100px !important;">
    <v-layout align-center justify-center>
      <v-progress-circular :size="100" :width="8" indeterminate color="blue"></v-progress-circular>
    </v-layout>
  </div>
  <div style="overflow-y: hidden !important;" class="leftbox" v-else>
    <v-tabs slot="extension" v-model="tabs" fixed-tabs color="transparent" icons-and-text centered>
      <v-tabs-slider></v-tabs-slider>
      <!-- <v-tab href="#tab-1" :key="1" v-if="status_event != 'false'">
        อีเวนท์
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">fas fa-calendar</v-icon>
      </v-tab> -->
      <v-tab href="#tab-1" :key="1">
        เพื่อน ({{formattotal(num_friends)}})
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">person</v-icon>
      </v-tab>
      <v-tab href="#tab-2" :key="2">
        กลุ่ม ({{formattotal(listgroup.length)}})
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">supervisor_account</v-icon>
      </v-tab>
      <v-tab href="#tab-3" :key="3">
        แชท ({{formattotal(listchat.length)}})
        <v-badge v-model="showcountread" color="red" v-if="num_countread !== 0">
          <span style="font-size: 12px;" slot="badge" v-if="num_countread >= 1000">999+</span>
          <span style="font-size: 12px;" slot="badge" v-else>{{num_countread}}</span>
          <v-icon style="font-size: 25px !important;color: #2562af !important;">chat</v-icon>
        </v-badge>
        <v-icon v-else style="font-size: 25px !important;color: #607d8b !important;">chat</v-icon>
      </v-tab>
      <v-tab href="#tab-4" :key="4">
        จัดการบัญชี
        <v-icon style="font-size: 25px !important;color: #607d8b !important;">settings</v-icon>
      </v-tab>
      <!-- <div style="position:absolute;">sdfsdfsdfsd</div> -->
      <!-- <span>sdsdfdfdsfsdfsdfsdfs</span> -->
    </v-tabs>
      <!-- <v-flex xs2 sm2 md2 class="d-flex align-center mr-2" > -->
        <!-- <v-select
          v-if="tabs == 'tab-3' && $vuetify.breakpoint.mdAndUp"
          class="selectFilter mr-4"
          :items="status_admin_list"
          v-model="status_admin"
          dense
          solo
          item-text="text"
          item-value="value"
          label="สถานะการตอบของแอดมิน"
          hide-details
          return-object
        >
          <template v-slot:item="{ item }">
            <v-flex xs2 sm2 md2>
              <v-icon :color="item.color">mdi-checkbox-blank-circle</v-icon>
            </v-flex>
            <v-flex class="ml-2">
              {{ item.text }}
            </v-flex>
          </template>
        </v-select> -->
            <!-- </v-flex> -->
    <v-tabs-items v-model="tabs" class="white elevation-1">
      <!-- <v-tab-item id="tab-1" style="height: calc(100vh - 64px);" class="scrolling-wrapper">
        <Event/>
      </v-tab-item> -->

      <v-tab-item id="tab-1" style="height: calc(100vh - 64px);">
        <v-list v-if="ProgressListFriend && roundgetFriend == 0">
          <v-progress-linear :indeterminate="ProgressListFriend"></v-progress-linear>
        </v-list>
        <v-list two-line v-else-if="listfriend.length != 0">
          <v-layout xs12 xl12 md12 sm12 lg12 style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
            <v-text-field append-icon="search" label="ค้นหาเพื่อนโดยพิมพ์ชื่อเพื่อน,วันอีเมลหรือเบอร์โทร..." solo clearable v-model="search" style="color: white !important;"></v-text-field>
          </v-layout>
          <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 250px);" class="scrolling-wrapper">
            <template v-for="(item, index) in FilterFriendList">
              <v-list-tile  avatar v-on:click="routechat(item)" v-if="actionF == item.tokenroom" :key="index">
                <v-list-tile-avatar>
                  <img :src="item.profilepicture" v-if="item.profilepicture" class="alligator-turtle">
                  <v-img :src="require('../assets/robot1.png')" v-else class="alligator-turtle"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title >{{ item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.status }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile  avatar v-on:click="routechat(item)" v-else :key="index">
                <v-list-tile-avatar>
                  <img :src="item.profilepicture" v-if="item.profilepicture" class="alligator-turtle">
                  <v-img :src="require('../assets/robot1.png')" v-else class="alligator-turtle"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title >{{ item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ item.status }}</v-list-tile-sub-title>
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < FilterFriendList.length" :key="`divider-${index}`"></v-divider>
            </template>
            <template v-if="nextgetFriend">
              <v-list-tile  avatar style="display: flex; justify-content: center;">
                <v-progress-linear :indeterminate="ProgressListFriend" v-if="ProgressListFriend" color="primary"></v-progress-linear>
                <v-btn @click="getlistfriendbot" v-else-if="search == '' || search == null" style="background: #5f7c8a; color: white; border-radius: 20px;"> โหลดเพื่อนเพิ่มเติม </v-btn>
              </v-list-tile>
            </template>
          </v-flex>
        </v-list>
        <v-list v-else>
          <v-layout align-center justify-center column fill-height>
            <div style="margin-top: 15%;">
              <v-img :src="require('../assets/robot1.png')" style="width: 100px;"></v-img>
              <h4>ไม่มีรายชื่อเพื่อน</h4>
            </div>
          </v-layout>
        </v-list>

      </v-tab-item>

      <v-tab-item id="tab-2" style="height: calc(100vh - 64px);">
        <v-list v-if="ProgressListFriend">
          <v-progress-linear :indeterminate="ProgressListFriend"></v-progress-linear>
        </v-list>
        <v-list two-line v-else-if="!ProgressListFriend && listgroup.length != 0">
          <v-layout xs12 xl12 md12 sm12 lg12 style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
            <v-text-field append-icon="search" label="ค้นหากลุ่ม..." solo clearable v-model="searchgroup" style="color: white !important;"></v-text-field>
          </v-layout>
          <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 250px);" class="scrolling-wrapper">
            <!-- <template v-for="(item, index) in ((search !== '' && search !== null)? FilterGroupList:listgroup)"> -->
              <template v-for="(item, index) in FilterGroupList">
              <v-list-tile  avatar v-on:click="routechat(item)" v-if="actionF == item.tokenroom" :key="index">
                <v-list-tile-avatar>
                  <img :src="item.picture" v-if="item.picture" class="alligator-turtle">
                  <v-img :src="require('../assets/group.png')" v-else class="alligator-turtle"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title >{{ item.name }}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>{{ item.status }}</v-list-tile-sub-title> -->
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>

              <v-list-tile  avatar v-on:click="routechat(item)" v-else :key="index">
                <v-list-tile-avatar>
                  <img :src="item.picture" v-if="item.picture" class="alligator-turtle">
                  <v-img :src="require('../assets/group.png')" v-else class="alligator-turtle"></v-img>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title >{{ item.name }}</v-list-tile-title>
                  <!-- <v-list-tile-sub-title>{{ item.status }}</v-list-tile-sub-title> -->
                </v-list-tile-content>

                <v-list-tile-action>
                </v-list-tile-action>
              </v-list-tile>
              <v-divider v-if="index + 1 < FilterGroupList.length" :key="`divider-${index}`"></v-divider>
            </template>
          </v-flex>
        </v-list>
        <v-list v-else>
          <v-layout align-center justify-center column fill-height>
            <div style="margin-top: 15%;">
              <v-img :src="require('../assets/group.png')" style="width: 100px;"></v-img>
              <h4>ไม่มีรายชื่อกลุ่ม</h4>
            </div>
          </v-layout>
        </v-list>
      </v-tab-item>

      <v-tab-item id="tab-3" style="height: calc(100vh - 64px);">
        <v-flex xs12 xl12 md12 sm12 lg12 >
          <v-list v-if="ProgressListChat && listchat_length === 0">
            <v-progress-linear :indeterminate="ProgressListChat"></v-progress-linear>
          </v-list>
          <v-list class="listChat" two-line v-else-if="listchat.length != 0">
            <v-layout align-start xs12 xl12 md12 sm12 lg12 style="margin-top: 15px; padding-left: 10px; padding-right: 10px;" v-if="listchat.length !== 0">
              <v-text-field append-icon="search" label="ค้นหาแชท..." solo clearable v-model="searchchat" style="color: white !important;"></v-text-field>
              <v-select
                class="selectFilter pl-2 pr-2"
                :items="status_admin_list"
                v-model="status_admin"
                dense
                solo
                item-text="text"
                item-value="value"
                label="สถานะการตอบของแอดมิน"
                hide-details
                prepend-inner-icon="mdi-filter"
              >
              <!--                 prepend-inner-icon="mdi-filter" -->
                <template v-slot:item="{ item }">
                  <v-flex xs2 sm2 md2>
                    <v-icon :color="item.color" v-if="item.color">mdi-checkbox-blank-circle</v-icon>
                  </v-flex>
                  <v-flex class="ml-2">
                    {{ item.text }}
                  </v-flex>
                </template>
              </v-select>
            </v-layout>
            <v-flex xs12 xl12 md12 sm12 lg12 style="height: calc(100vh - 250px);" class="scrolling-wrapper" v-if="listchat.length !== 0">
              <template v-for="(item, index) in FilterChatList">
                   <!-- {{item}} -->
                <v-list-tile avatar v-on:click="routechat(item)" v-if="actionF == item.tokenroom" :key="index">
                  <v-list-tile-avatar>
                    <img :src="item.picture" v-if="item.picture" class="alligator-turtle">
                    <v-img :src="require('../assets/robot1.png')" v-else-if="item.type == 'user'" class="alligator-turtle"></v-img>
                    <img :src="require('../assets/group.png')" v-else-if="item.type == 'group' || item.type == 'Group'" class="alligator-turtle">
                    <img :src="require('../assets/robot1.png')" v-else-if="item.type == 'bot'" class="alligator-turtle">
                    <v-img :src="require('../assets/robot1.png')" v-else class="alligator-turtle"></v-img>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-list-tile-title>{{ item.name }}</v-list-tile-title>
                    <!-- <v-list-tile-sub-title class="fontchat ">
                      <span class='fontchat ' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                        คุณได้ออกจากการสนทนาแล้ว
                      </span>
                      <span class='fontchat ' v-else-if="item.name !== ''" style="font-size: 11px!important;">
                       {{ item.message }}
                      </span>
                      <span class='fontchat ' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'" style="font-size: 11px!important;">
                        เริ่มต้นการสนทนา
                      </span>
                    </v-list-tile-sub-title> -->
                    <v-list-tile-sub-title class="fontchat">
                      <span class="fontchat" v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                        คุณได้ออกจากการสนทนา
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'message'" style="font-size: 11px!important;" v-html="convertMention(item.message)">
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                        ส่งสติ้กเกอร์
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file'" style="font-size: 11px!important;">
                        ส่งไฟล์
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                        ส่งสถานที่
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                        ส่งรายการติดต่อ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                        ส่งรูปภาพ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                        ส่งโน๊ต
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                        ส่งวิดีโอ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                        ตอบกลับข้อความ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                        สร้างอัลบั้ม
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                        สร้างการ์ดงาน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                        สร้างโปรเจคงาน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'approve_message'" style="font-size: 11px!important;">
                        ส่งแบบฟอร์มยืนยัน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                        {{item.message}}
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                        ส่งข้อความรูปภาพ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime' || item.typeofmessage === 'official_template'" style="font-size: 11px!important;">
                        {{item.message}}
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                        <div v-if="item.message === 'invite'">
                          {{item.nickname}} เชิญ {{item.file_name}}
                        </div>
                        <div v-else-if="item.message === 'kick'">
                          {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser === token">
                          คุณอกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser !== token">
                          {{item.nickname}} ออกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser === token">
                          คุณเข้าร่วมกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser !== token">
                          {{item.nickname}} เข้าร่วมกลุ่ม
                        </div>
                      </span>
                      <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px!important;">
                        เริ่มต้นการสนทนา
                      </span>
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <v-layout align-end justify-start row fill-height>
                      <p style="margin-right: 7vw; color: rgb(82, 82, 82) !important; font-size: 11px;" v-if="item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">{{time(item.timestamp)}}
                      </p>
                      <p style="margin-right: 7vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                        <v-badge color="red">
                          <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                          <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                          <!-- <span v-else-if="item.count_read == NaN" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >1</span> -->
                        </v-badge>
                      </p>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>

                <v-list-tile avatar v-on:click="routechat(item)" v-else :key="index">
                  <v-list-tile-avatar>
                    <img :src="item.picture" v-if="item.picture" class="alligator-turtle">
                    <v-img :src="require('../assets/robot1.png')" v-else-if="item.type == 'user'" class="alligator-turtle"></v-img>
                    <img :src="require('../assets/group.png')" v-else-if="item.type == 'group' || item.type == 'Group'" class="alligator-turtle">
                    <img :src="require('../assets/robot1.png')" v-else-if="item.type == 'bot'" class="alligator-turtle">
                    <v-img :src="require('../assets/robot1.png')" v-else class="alligator-turtle"></v-img>
                  </v-list-tile-avatar>

                  <v-list-tile-content>
                    <v-layout row wrap align-center>
                      <v-flex>
                          <v-list-tile-title style="height:28px;">
                            {{ item.name }}
                            <v-chip outline dark small v-if="item.official_status == 'admin'" color="#0B7A09">แอดมิน</v-chip>
                            <v-chip outline dark small v-if="item.official_status == 'waiting'" color="#E28800">รอแอดมิน</v-chip>
                            <v-chip outline dark small v-if="item.official_status == ''" color="#7C7D81">ปกติ</v-chip>
                          </v-list-tile-title>
                    <!-- <v-list-tile-sub-title class="fontchat ">
                      <span class='fontchat ' v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                        คุณได้ออกจากการสนทนาแล้ว
                      </span>
                      <span class='fontchat ' v-else-if="item.name !== ''" style="font-size: 11px!important;">
                       {{ item.message }}
                      </span>
                      <span class='fontchat ' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user'" style="font-size: 11px!important;">
                        เริ่มต้นการสนทนา
                      </span>
                    </v-list-tile-sub-title> -->
                    <v-list-tile-sub-title class="fontchat">
                      <span class="fontchat" v-if="item.state !== 'friend' && item.state !== 'active' && item.state !== 'group' && item.state !== 'user'" style="font-size: 11px!important;">
                        คุณได้ออกจากการสนทนา
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'message'" style="font-size: 11px!important;" v-html="convertMention(item.message)">
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'sticker'" style="font-size: 11px!important;">
                        ส่งสติ้กเกอร์
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'file' || item.typeofmessage === 'password_file'" style="font-size: 11px!important;">
                        ส่งไฟล์
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'location'" style="font-size: 11px!important;">
                        ส่งสถานที่
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'contact'" style="font-size: 11px!important;">
                        ส่งรายการติดต่อ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'image'" style="font-size: 11px!important;">
                        ส่งรูปภาพ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'note'" style="font-size: 11px!important;">
                        ส่งโน๊ต
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'video'" style="font-size: 11px!important;">
                        ส่งวิดีโอ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'mention_message'" style="font-size: 11px!important;">
                        ตอบกลับข้อความ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'albums_message'" style="font-size: 11px!important;">
                        สร้างอัลบั้ม
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'task_message'" style="font-size: 11px!important;">
                        สร้างการ์ดงาน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system_action_task'" style="font-size: 11px!important;">
                        สร้างโปรเจคงาน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'approve_message'" style="font-size: 11px!important;">
                        ส่งแบบฟอร์มยืนยัน
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'carousel'" style="font-size: 11px!important;">
                        ส่งข้อความรูปภาพ
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'unsend_message'" style="font-size: 11px!important;">
                        {{item.message}}
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system' || item.typeofmessage === 'template' || item.typeofmessage === 'date' || item.typeofmessage === 'datetime' || item.typeofmessage === 'official_template'" style="font-size: 11px!important;">
                        {{item.message}}
                      </span>
                      <span class="fontchat" v-else-if="item.typeofmessage === 'system_action'" style="font-size: 11px!important;">
                        <div v-if="item.message === 'invite'">
                          {{item.nickname}} เชิญ {{item.file_name}}
                        </div>
                        <div v-else-if="item.message === 'kick'">
                          {{item.nickname}} ลบ {{item.file_name}} ออกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser === token">
                          คุณอกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'leave' && item.tokenuser !== token">
                          {{item.nickname}} ออกจากกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser === token">
                          คุณเข้าร่วมกลุ่ม
                        </div>
                        <div v-else-if="item.message === 'active' && item.tokenuser !== token">
                          {{item.nickname}} เข้าร่วมกลุ่ม
                        </div>
                      </span>
                      <span class='fontselectchat' v-else-if="item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user' && item.typeofmessage !== 'message'" style="font-size: 11px!important;">
                        เริ่มต้นการสนทนา
                      </span>
                    </v-list-tile-sub-title>
                      </v-flex>
                      <v-flex>
                        <!-- <v-layout align-start>
                        <v-chip outline dark small v-if="status_admin == 'admin'" color="#0B7A09">แอดมิน</v-chip>
                        <v-chip outline dark small v-if="status_admin == 'waiting'" color="#E28800">รอแอดมิน</v-chip>
                        <v-chip outline dark small v-if="status_admin == 'auto'" color="#7C7D81">ปกติ</v-chip>
                        </v-layout> -->
                        <!-- <div style="width:73px; height:19px; border-radius:10px; background-color: #0B7A09; color:white;" >
                          <span>แอดมิน</span>
                        </div> -->
                      </v-flex>
                    </v-layout>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-layout align-end justify-start row fill-height>
                      <p style="margin-right: 7vw; color: rgb(82, 82, 82) !important; font-size: 11px;" v-if="item.timestamp !== '' && (item.state === 'friend' || item.state === 'active' || item.state === 'group' || item.state === 'user')">{{time(item.timestamp)}}
                      </p>
                      <p style="margin-right: 7vw;" v-if="item.state == 'friend' || item.state == 'active' || item.state == 'group' || item.state == 'user'">
                        <v-badge color="red">
                          <span slot="badge" class="Kanit" style="font-size: 12px;" v-if="parseInt(item.count_read) >= 1000">999+</span>
                          <span v-else-if="item.count_read != '' && parseInt(item.count_read) != 0" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >{{item.count_read}}</span>
                          <!-- <span v-else-if="item.count_read == NaN" slot="badge" style="font-size: 11px; text-align: center;" class="Kanit" >1</span> -->
                        </v-badge>
                      </p>
                    </v-layout>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider v-if="index + 1 < FilterChatList.length" :key="`divider-${index}`"></v-divider>
              </template>
              <template v-if="nextgetChat">
                <v-progress-linear :indeterminate="ProgressListChat" v-if="ProgressListChat" color="primary"></v-progress-linear>
                <v-list-tile  avatar style="display: flex; justify-content: center;" v-else-if="searchchat == '' || searchchat == null">
                  <v-btn @click="getlistchat()" style="background: #5f7c8a; color: white; border-radius: 20px;"> โหลดแชทเพิ่มเติม </v-btn>
                </v-list-tile>
              </template>
            </v-flex>
            <!-- <v-flex xs12 xl12 md12 sm12 lg12 v-else>
              <v-list>
                <v-layout align-center justify-center column fill-height>
                  <v-img src="https://image.flaticon.com/icons/svg/134/134932.svg" style="width: 100px;"></v-img>
                  <h4>ไม่มีรายการแชท</h4>
                </v-layout>
              </v-list>
            </v-flex> -->
          </v-list>
          <v-list v-else>
            <v-layout align-center justify-center column fill-height v-if="status_admin == 'all'">
              <div style="margin-top: 15%;" >
                <v-img :src="require('../assets/bubble.png')" style="width: 100px;"></v-img>
                <!-- <v-icon style="height: 100px;" color="primary">fas fa-comments</v-icon> -->
                <h4>ไม่มีรายการแชท</h4>
              </div>
            </v-layout>
            <!-- <v-layout align-center justify-center column fill-height v-if="status_admin != 'all'">
              <span>tesllllllllllllllllll</span>
            </v-layout> -->
            <template v-else>
              <v-layout justify-end style="margin-top: 15px; padding-left: 10px; padding-right: 10px;">
                <!-- <v-spacer></v-spacer> -->
              <v-text-field disabled append-icon="search" label="ค้นหาแชท..." solo clearable v-model="searchchat" style="color: white !important;"></v-text-field>
                <v-select
                  class="selectFilter pl-2 pr-2"
                  :items="status_admin_list"
                  v-model="status_admin"
                  dense
                  solo
                  item-text="text"
                  item-value="value"
                  label="สถานะการตอบของแอดมิน"
                  hide-details
                  prepend-inner-icon="mdi-filter"
                >
                <!--                 prepend-inner-icon="mdi-filter" -->
                  <template v-slot:item="{ item }">
                    <v-flex xs2 sm2 md2>
                      <v-icon :color="item.color" v-if="item.color">mdi-checkbox-blank-circle</v-icon>
                    </v-flex>
                    <v-flex class="ml-2">
                      {{ item.text }}
                    </v-flex>
                  </template>
                </v-select>
              </v-layout>
              <v-layout align-center justify-center column fill-height>
                <div style="margin-top: 10%;" >
                  <v-img :src="require('../assets/bubble.png')" style="width: 100px;"></v-img>
                  <!-- <v-icon style="height: 100px;" color="primary">fas fa-comments</v-icon> -->
                  <h4>ไม่มีข้อมูลแชท</h4>
                </div>
            </v-layout>

            </template>
          </v-list>
        </v-flex>
      </v-tab-item>

      <v-tab-item id="tab-4" style="height: calc(100vh - 64px);" class="scrolling-wrapper">
        <v-list two-line v-if="status_event != 'true'">
          <template v-for="(item, index) in listsetting">
            <v-list-tile  :key="index" @click="toPage(item.dialog)" >
              <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;
                <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            <v-divider v-if="index + 1 < listsetting.length" :key="`divider-${index}`"></v-divider>
          </template>
          <!-- bc carausel -->
          <!-- <template v-if="$route.params.id === 'Bc020e95179a450548a3c1905d2280f15'">
            <v-list-tile @click="toPage()" >
              <v-icon meduim>fas fa-bullhorn</v-icon>&nbsp;&nbsp;
                <v-list-tile-title class="CSChatThai">บรอดแคสข้อความรูปภาพ</v-list-tile-title>
            </v-list-tile>
          </template> -->
        </v-list>
        <v-list two-line v-else>
          <template v-for="(item, index) in listsettingevent">
            <v-list-tile  :key="index" @click="toPage(item.dialog)" >
              <v-icon meduim>{{item.icon}}</v-icon>&nbsp;&nbsp;
                <v-list-tile-title class="CSChatThai">{{ item.title }}</v-list-tile-title>
            </v-list-tile>
            <v-divider v-if="index + 1 < listsettingevent.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>
<script>
import { Momenttime, Decode } from '@/services'
import { sync } from 'vuex-pathify'
// import Event from '@/components/Event'
var _ = require('lodash')
// var config = {
//   headers: {
//     'Content-Type': 'application/json'
//   }
// };
export default {
  components: {
    // Event
  },
  data: () => ({
    status_admin_list: [
      { text: 'ทั้งหมด', value: 'all', color: '' },
      { text: 'ปกติ', value: '', color: '#7C7D81' },
      { text: 'รอแอดมิน', value: 'waiting', color: '#E28800' },
      { text: 'แอดมิน', value: 'admin', color: '#0B7A09' }
    ],
    // status_admin:[
    //   {'text': 'แอดมิน' ,},
    //   {'text': 'รอแอดมิน'},
    //   {'text': 'ปกติ'},
    // ],
    // status_admin: 'waiting',
    status_admin: 'all',
    // status_admin: 'admin',
    // status_admin: '',
    searchchat: '',
    showcountread: false,
    num_countread: '',
    tabs: 'tab-1',
    tokenservice: '',
    listfriend: [],
    listchat: [],
    listsetting: [
      {
        title: 'แก้ไขโปรไฟล์ร้านค้า',
        icon: 'person',
        dialog: '/account/settings/profile/'
      },
      {
        title: 'เพิ่มแอดมิน',
        icon: 'person_add',
        dialog: '/account/settings/addadmin/'
      },
      {
        title: 'จัดการเพื่อน',
        icon: 'fas fa-users',
        dialog: '/account/settings/managefriend/'
      },
      {
        title: 'บรอดแคสต์ข้อความ',
        icon: 'fas fa-bullhorn',
        dialog: '/account/settings/broadcast/'
      }
      // {
      //   title: 'ตอบกลับข้อความอัตโนมัติ',
      //   icon: 'fas fa-reply',
      //   dialog: '/account/settings/autoreply/'
      // }
    ],
    listsettingevent: [
      {
        title: 'แก้ไขโปรไฟล์ร้านค้า',
        icon: 'person',
        dialog: '/account/settings/profile/'
      },
      {
        title: 'เพิ่มแอดมิน',
        icon: 'person_add',
        dialog: '/account/settings/addadmin/'
      },
      {
        title: 'จัดการเพื่อน',
        icon: 'fas fa-users',
        dialog: '/account/settings/managefriend/'
      },
      {
        title: 'บรอดแคสต์ข้อความ',
        icon: 'fas fa-bullhorn',
        dialog: '/account/settings/broadcast/'
      }
      // {
      //   title: 'ข้อมูลเกี่ยวกับ event',
      //   icon: 'fas fa-calendar',
      //   dialog: '/account/settings/event/'
      // }
    ],
    progress: false,
    ProgressListChat: false,
    ProgressListFriend: false,
    search: '',
    actionF: '',
    status_login: '',
    status_event: '',
    listgroup: [],
    searchgroup: '',
    tokenuser: '',
    roundgetFriend: 0,
    nextgetFriend: true,
    nextgetChat: true,
    FilterFriendList: [],
    listchat_length: 0,
    num_friends: 0
  }),
  computed: {
    FilterGroupList () {
      if (this.searchgroup !== '' && this.searchgroup !== null) {
        return this.listgroup.filter(post => {
          return post.name.toLowerCase().includes(this.searchgroup.toLowerCase())
        })
      } else {
        return this.listgroup
      }
    },
    // FilterFriendList () {
    //   if (this.search !== '' && this.search !== null) {
    //     return this.searchFriend()
    //   } else {
    //     return this.listfriend
    //   }
    // },
    FilterChatList () {
      if (this.searchchat !== '' && this.searchchat !== null) {
        return this.listchat.filter(post => {
          return post.name.toLowerCase().includes(this.searchchat.toLowerCase())
        })
      } else {
        return this.listchat
      }
      // else if (this.status_admin != 'all'){
      //   return this.listchat.filter(item => item.official_status == this.status_admin.value);
      // }
    },
    ...sync('*')
  },
  // sockets: {
  //   message (data) {
  //     console.log('message info bot '+ data)
  //   },
  //   connect () {
  //     console.log('socket connected infobot')
  //     // console.log(localStorage.getItem('tokenbot'))
  //     this.$socket.emit('join', { room: localStorage.getItem('tokenbot'), type: 'web' })
  //   }
  // },
  watch: {
    status_admin () {
      console.log(this.status_admin)
      localStorage.setItem('status_admin', this.status_admin)
      this.ProgressListChat = true
      this.listchat_length = 0
      console.log(`bot listchat: ${process.env.VUE_APP_BOT_LISTCHAT}`)
      var api_listchat = ''
      if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
        api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
      } else {
        api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
      }
      // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
      // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
      this.axios.post(api_listchat, { tokenuser: this.$route.params.id, chat_count: 0, official_status: this.status_admin }).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListChat = false
          this.listchat = response.data.listchat
          // this.listchat_length = this.listchat.length
          // if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
          //   this.listchat_length = this.listchat_length + 1
          // } else {
          //   this.listchat_length = this.listchat.length
          // }
          this.listchat_length = this.listchat_length + 1
          localStorage.setItem('listchat', JSON.stringify(this.listchat))
          localStorage.setItem('listchat_length', response.data.listchat.length)
          if (response.data.listchat.length === 20) {
            this.nextgetChat = true
          } else {
            this.nextgetChat = false
          }
          // this.getnotcountread()
          var indexblock = []
          var indexmessage = []
          var indexactive = []
          indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
          indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
          indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
          var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
          var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
          var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
          var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
          this.num_countread = count - (countblock + countmsg + countactive)
          if (this.num_countread !== 0) {
            this.showcountread = true
          } else {
            this.showcountread = false
          }
        } else {
          this.ProgressListChat = false
        }
      }).catch(error => {
        console.log(error)
        this.ProgressListChat = false
      })
    },
    socketmarkread (data) {
      // console.log(data)
    },
    search () {
      if (this.search !== '' && this.search !== null) {
        this.searchFriend(this.search)
      } else {
        this.FilterFriendList = this.listfriend
      }
    },
    block_friend (data) {
      this.blockevent(data)
    },
    chIsactive (data) {
      // console.log(data)
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/setisactive', { tokenroom: data, tokenuser: localStorage.getItem('tokenbot'), is_active: 'false' }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data })
          this.listchat[indexmsg].is_active = false
          this.$router.push('/account/' + this.$route.params.id)
        }
      })
    },
    '$route.params.id' () {
      console.log(this.$route.params.id)
      this.listchat_length = 0
      this.roundgetFriend = 0
      this.num_friends = 0
      this.listfriend = []
      this.listchat = []
      this.nextgetFriend = true
      this.status_admin = 'all'
      localStorage.setItem('tabs', 'tab-1')
      localStorage.setItem('status_admin', 'all')
      localStorage.removeItem('listchat')
      this.tabs = 'tab-1'
      this.getlistfriendbot()
      this.getlistgroup()
      this.getlistchat()
      this.checkbotAutoreply()
      // this.getlistevent()
      // console.log(this.$route.params.id)
    },
    '$route.params.roomid' () {
      this.actionF = this.$route.params.roomid
    },
    socket_official_status (data) {
      // console.log(data)
      var me = this
      var index = _.findIndex(me.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (index !== -1) {
        me.listchat[index].official_status = data.status
      }
    },
    socketmessage (data) {
      // console.log(this.socketmessage)
      this.listchat = JSON.parse(localStorage.getItem('listchat'))
      if (this.listchat === null) {
        console.log(`listchat: ${this.listchat}`)
        this.getlistchat()
      } else {
        // console.log(data)
        // console.log(localStorage.getItem('listchat'))
        // console.log(this.listchat)
        if (data.typeofmessage !== 'system_action') {
          var me = this
          console.log(data.typeofmessage)
          var indexmsg = _.findIndex(me.listchat, function (o) { return o.tokenroom === data.tokenroom })
          // console.log(indexmsg)
          // console.log(this.listchat[indexmsg])
          if (indexmsg !== -1) {
            this.listchat[indexmsg].is_active = 'true'
            var message = data.message
            if (data.tokenuser !== this.$route.params.id) {
              // console.log(data.tokenuser !== this.$route.params.id)
              this.listchat[indexmsg].count_read = parseInt(this.listchat[indexmsg].count_read) + 1

              if (indexmsg === 0) {
                this.listchat[0].message = message
                this.listchat[0].timestamp = data.timestamp
                this.listchat[0].name = data.nickname
                this.listchat[0].typeofmessage = data.typeofmessage
                this.listchat[0].time_count = data.time_count
                this.listchat[0].file_name = data.file_name
                this.listchat[0].tokenuser = data.tokenuser
                this.listchat[0].picture = data.path_pic
                this.listchat[0].state = 'active'
                // this.listchat[0].count_read = parseInt(this.listchat[0].count_read) + 1
              } else {
                var dataindex = this.listchat[indexmsg]
                dataindex.message = message
                dataindex.timestamp = data.timestamp
                dataindex.name = data.nickname
                dataindex.typeofmessage = data.typeofmessage
                dataindex.time_count = data.time_count
                dataindex.file_name = data.file_name
                dataindex.tokenuser = data.tokenuser
                dataindex.picture = data.path_pic
                dataindex.state = 'active'
                // dataindex.count_read = parseInt(this.listchat[indexmsg].count_read) + 1

                _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
                this.listchat.unshift(dataindex) // เพิ่ม lischat ใหม่เข้าไป
                this.listchat = _.unionBy(this.listchat, 'tokenroom')
              }

              var indexblock = []
              var indexmessage = []
              var indexactive = []
              indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
              indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
              indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })

              var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
              var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
              var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })

              var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
              this.num_countread = count - (countblock + countmsg + countactive)
              if (this.num_countread !== 0) {
                this.showcountread = true
              } else {
                this.showcountread = false
              }
            } else {
              // console.log('test')
              if (indexmsg === 0) {
                this.listchat[0].message = message
                this.listchat[0].timestamp = data.timestamp
                this.listchat[0].typeofmessage = data.typeofmessage
                this.listchat[0].time_count = data.time_count
                this.listchat[0].file_name = data.file_name
                this.listchat[0].tokenuser = data.tokenuser
              } else {
                var dataindexs = this.listchat[indexmsg]
                dataindexs.message = message
                dataindexs.timestamp = data.timestamp
                dataindexs.typeofmessage = data.typeofmessage
                dataindexs.time_count = data.time_count
                dataindexs.file_name = data.file_name
                dataindexs.tokenuser = data.tokenuser
                _.pullAt(this.listchat, indexmsg) // ลบ listchat เดิม
                this.listchat.unshift(dataindexs) // เพิ่ม lischat ใหม่เข้าไป
                this.listchat = _.unionBy(this.listchat, 'tokenroom')
              }
            }
            localStorage.setItem('listchat', JSON.stringify(this.listchat))
            // this.listchat_length = this.listchat.length
            this.listchat_length = this.listchat_length + 1
          } else {
            console.log('get new chat')
            // console.log(JSON.parse(localStorage.getItem('listchat')))
            // console.log(this.status_admin)
            // ไม่มีใน listcaht ปัจจุบัน
            this.axios.post(process.env.VUE_APP_API_GOAPI + '/api/v4/getRoomDataForOfficial', { bot_id: this.$route.params.id, tokenroom: data.tokenroom }).then((response) => {
              // console.log(response.data)
              if (response.data !== 'room_or_bot_id_not_found') {
                // console.log(response.data.official_status === this.status_admin)
                console.log(this.status_admin)
                if (response.data.official_status === this.status_admin) {
                  // console.log(JSON.parse(localStorage.getItem('listchat')))
                  if (JSON.parse(localStorage.getItem('listchat')) !== null) {
                    this.listchat.unshift(response.data)
                    this.listchat = _.unionBy(this.listchat, 'tokenroom')
                    // console.log(this.listchat)
                    localStorage.setItem('listchat', JSON.stringify(this.listchat))
                    // this.listchat_length = this.listchat.length
                    this.listchat_length = this.listchat_length + 1
                  }
                } else if (this.status_admin === 'all') {
                  this.listchat.unshift(response.data)
                  this.listchat = _.unionBy(this.listchat, 'tokenroom')
                  // console.log(this.listchat)
                  localStorage.setItem('listchat', JSON.stringify(this.listchat))
                  // this.listchat_length = this.listchat.length
                  this.listchat_length = this.listchat_length + 1
                }
              }
            }).catch(error => {
              console.log(error)
            })
          }
        }
        // localStorage.setItem('listchat', JSON.stringify(this.listchat))
        // this.listchat_length = this.listchat.length
      }
    },
    socketaccept_friend (data) {
      // console.log(data)
      var tokenfriend = data.tokenfriend
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/searchtokenuser', { tokenuser: this.$route.params.id, tokenfriend: tokenfriend }).then((response) => {
        if (_.find(this.listfriend, function (o) { return o.tokenuser === response.data.user.tokenuser }) === undefined) {
          this.listfriend.unshift(response.data.user)
          this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
          this.num_friends = this.listfriend.length
          localStorage.setItem('num_friends', this.num_friends)
        }
        if (data.tokenfriend !== this.$route.params.id) {
          // update listchat
          var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
          // console.log(indexchat)
          var json = response.data.user
          json.name = response.data.user.name
          json.picture = response.data.user.profilepicture
          json.state = 'user'
          json.timestamp = data.timestamp
          json.count_read = 0
          json.is_active = 'true'
          if (indexchat >= 0) {
            this.listchat.splice(indexchat, 1)
            this.listchat.unshift(json)
          } else {
            this.listchat.unshift(json)
          }
          localStorage.setItem('listchat', JSON.stringify(this.listchat))
          // this.listchat_length = this.listchat.length
          this.listchat_length = this.listchat_length + 1
        }
      })
    },
    socketremove_friend (data) {
      var index = _.findIndex(this.listfriend, function (o) { return o.tokenroom === data.tokenroom })
      if (index >= 0) {
        this.listfriend.splice(index, 1)
        this.num_friends = this.listfriend.length
        localStorage.setItem('num_friends', this.num_friends)
      }
      var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      if (indexchat >= 0) {
        this.listchat[indexchat].state = 'unfriend'
        var indexblock = []
        var indexmessage = []
        var indexactive = []
        // var indextokenuser = []
        indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
        indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
        indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
        // indextokenuser = _.filter(this.listchat, function (listchat) { return listchat.tokenuser !== this.$route.params.id })

        var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
        var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
        var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
        // var counttokenuser = _.sumBy(indextokenuser, function (o) { return parseInt(o.count_read) })

        var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
        this.num_countread = count - (countblock + countmsg + countactive)
        // console.log(this.num_countread)
        if (this.num_countread !== 0) {
          this.showcountread = true
        } else {
          this.showcountread = false
        }
      }
    },
    socketleave_group (data) {
      // console.log(data)
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.$route.params.id) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
            // self.axios.post(process.env.APImanage + '/setpin', {tokenroom: data.tokenroom, tokenuser: self.token, pin: 'false'}).then((response) => {
            //   var listpin = []
            //   var linstunpin = []
            //   self.listchat[indexchat].pin = 'false'
            //   self.listchat = _.partition(self.listchat, function(o) { return o.pin == 'true' })
            //   listpin = _.orderBy(this.listchat[0], 'timestamp', 'desc')
            //   linstunpin = _.orderBy(this.listchat[1], 'timestamp', 'desc')
            //   self.listchat = _.union(listpin, linstunpin)
            // })
          }
        }
      })
    },
    socket_kickmember (data) {
      // console.log(data)
      var self = this
      data.listkick.forEach(function (item) {
        if (item === self.$route.params.id) {
          var index = _.findIndex(self.listgroup, function (o) { return o.tokenroom === data.tokenroom })
          if (index >= 0) {
            self.listgroup.splice(index, 1)
          }
          var indexchat = _.findIndex(self.listchat, function (o) { return o.tokenroom === data.tokenroom })
          if (indexchat >= 0) {
            self.listchat[indexchat].state = 'leave'
          }
        }
      })
    },
    socketactive_group (data) {
      // console.log(data)
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getgroup', { group_id: data.groupid, tokenuser: this.$route.params.id }).then((response) => {
        // update listgroup
        // console.log(response.data.group)
        if (_.find(this.listgroup, function (o) { return o.group_id === response.data.group.group_id }) === undefined) {
          var group = response.data.group
          group.timestamp = data.timestamp
          this.listgroup.unshift(group)
          this.listgroup = _.orderBy(this.listgroup, ['name'], ['asc'])
        }
        // update listchat
        if (data.tokenuser === this.$route.params.id) {
          var indexchat = _.findIndex(this.listchat, function (o) { return o.tokenroom === response.data.group.tokenroom }) // หาตำแหน่งของ group req ที่ต้องการจะลบ
          // console.log(indexchat)
          if (indexchat !== -1) {
            this.listchat[indexchat].state = 'active'
          }
        }
      })
    },
    tabs () {
      localStorage.setItem('tabs', this.tabs)
      console.log(this.status_admin)
      this.status_admin = localStorage.getItem('status_admin')
      this.listchat_length = 0
      if (this.tabs === 'tab-3') {
        var api_listchat = ''
        if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
          api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
        } else {
          api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
        }
        // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
        // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
        this.ProgressListChat = true
        this.axios.post(api_listchat, { tokenuser: this.$route.params.id, chat_count: this.listchat_length, official_status: this.status_admin }).then((response) => {
          // console.log(response.data.listchat)
          if (response.data.status === 'success') {
            this.ProgressListChat = false
            this.listchat = response.data.listchat
            // if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
            //   this.listchat_length = this.listchat_length + 1
            // } else {
            //   this.listchat_length = this.listchat.length
            // }
            this.listchat_length = this.listchat_length + 1
            localStorage.setItem('listchat', JSON.stringify(this.listchat))
            localStorage.setItem('listchat_length', response.data.listchat.length)
            if (response.data.listchat.length === 20) {
              this.nextgetChat = true
            } else {
              this.nextgetChat = false
            }
            // this.getnotcountread()
            var indexblock = []
            var indexmessage = []
            var indexactive = []
            indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
            indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
            indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
            var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
            var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
            var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
            var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
            this.num_countread = count - (countblock + countmsg + countactive)
            if (this.num_countread !== 0) {
              this.showcountread = true
            } else {
              this.showcountread = false
            }
          } else {
            this.ProgressListChat = false
          }
        }).catch(err => {
          console.log(err)
          this.ProgressListChat = false
        })
      }
    }
  },
  created () {
    this.tokenservice = 'Bearer ' + Decode.decodeToken(localStorage.getItem('tokenservice'))
    this.tokenuser = Decode.decodeToken(localStorage.getItem('tokenuser'))
    // console.log(localStorage.getItem('tabs'))
    if (localStorage.getItem('tabs') === null || localStorage.getItem('tabs') === undefined) {
      this.tabs = 'tab-1'
      // localStorage.setItem('tabs', this.tabs)
    } else {
      this.tabs = localStorage.getItem('tabs')
    }
    if (localStorage.getItem('status_admin') === null || localStorage.getItem('status_admin') === undefined) {
      this.status_admin = 'all'
      localStorage.setItem('status_admin', this.status_admin)
    } else {
      this.status_admin = localStorage.getItem('status_admin')
    }
    // console.log(this.$route.params.id)
    // console.log(JSON.parse(localStorage.getItem('listchat')))

    if (JSON.parse(localStorage.getItem('listchat')) === null || JSON.parse(localStorage.getItem('listchat')) === undefined) {
      this.getlistchat()
    } else {
      this.listchat = JSON.parse(localStorage.getItem('listchat'))
      // this.listchat_length = this.listchat.length
      this.listchat_length = 0
      // console.log(this.listchat)
      var indexblock = []
      var indexmessage = []
      var indexactive = []
      indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
      indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
      indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
      var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
      var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
      var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
      var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
      this.num_countread = count - (countblock + countmsg + countactive)
      if (this.num_countread !== 0) {
        this.showcountread = true
      } else {
        this.showcountread = false
      }

      if (parseInt(localStorage.getItem('listchat_length')) === 20) {
        this.nextgetChat = true
      } else {
        this.nextgetChat = false
      }
    }

    this.getlistfriendbot()
    // this.getlistchat()
    // this.getlistevent()
    this.getlistgroup()
    this.checkbotAutoreply()
  },
  methods: {
    formattotal (text) {
      var data = parseInt(text)
      if (data !== null && data !== '' && data !== undefined) {
        return data.toLocaleString('en-US')
      } else {
        return data
      }
    },
    async searchFriend (search) {
      var me = this
      await setTimeout(function () {
        if (me.search !== '' && me.search !== null) {
          me.axios.post(process.env.VUE_APP_API_MANAGE + '/filter_friend', { key: me.search, tokenuser: me.$route.params.id }).then((response) => {
            if (response.data.status === 'success') {
              if (me.search !== '' && me.search !== null) {
                me.FilterFriendList = response.data.listfriend
              } else {
                me.FilterFriendList = me.listfriend
              }
            }
          }).catch(err => {
            console.log(err)
          })
        }
      }, 500)
    },
    convertMention (msg) {
      msg = msg.replace(/<tax>/g, '<span style="color:#1976d2;">@')
      msg = msg.replace(/<\/tax>/g, '</span>')
      // console.log(msg)
      return msg
    },
    getlistevent () {
      this.axios.post(process.env.VUE_APP_API_DEVELOP + '/get/list_event', { tokenbot: this.$route.params.id, tokenuser: this.tokenuser }).then((response) => {
        if (response.data.status === 'success') {
          localStorage.setItem('event', 'true')
          this.status_event = localStorage.getItem('event')
          // console.log('status_event =>' + this.status_event)
          // console.log(localStorage.getItem('event'))
          this.progress = false
        } else {
          this.progress = true
        }
      }).catch(err => {
        localStorage.setItem('event', 'false')
        this.status_event = localStorage.getItem('event')
        console.log(err)
      })
    },
    blockevent (data) {
      // console.log(data)
      if (data.event === 'block_friend') {
        var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenuser === data.tokenuser })
        this.listchat[indexmsg].timestamp = data.timestamp
        this.listchat[indexmsg].state = 'block'
        this.listchat = _.orderBy(this.listchat, ['timestamp'], ['asc']).reverse()
        indexmsg = _.findIndex(this.listfriend, function (o) { return o.tokenuser === data.tokenuser })
        _.pullAt(this.listfriend, indexmsg)
      } else if (data.event === 'unblock_friend') {
        this.listfriend.push(data)
        this.listfriend = _.orderBy(this.listfriend, ['name'], ['asc'])
        indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
        this.listchat[indexmsg].state = 'active'
        this.listchat[indexmsg].nickname = ''
      }
    },
    time (timestamp) {
      return Momenttime.momenttimethaiformnow(timestamp)
    },
    getlistfriendbot () {
      if (this.nextgetFriend) {
        this.ProgressListFriend = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/listfriend_new', { tokenuser: this.$route.params.id, round_num: this.roundgetFriend.toString() }).then((response) => {
          if (response.data.status === 'success') {
          //   // console.log(response.data)
            if (response.data.listfriend.length === 20) {
              this.nextgetFriend = true
            } else {
              this.nextgetFriend = false
            }
            this.roundgetFriend = this.roundgetFriend + 1
            this.ProgressListFriend = false
            this.listfriend = this.listfriend.concat(response.data.listfriend)
            this.listfriend = _.unionBy(this.listfriend, 'tokenroom')
            // console.log(this.listfriend)
            this.FilterFriendList = this.listfriend
            this.num_friends = response.data.friend_count
            localStorage.setItem('num_friends', response.data.friend_count)
          } else {
            this.ProgressListFriend = true
          }
        }).catch(err => {
          console.log(err)
        })
      }
    },
    getlistgroup () {
      this.ProgressListFriend = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/web/getlistgroup', { tokenuser: this.$route.params.id }).then((response) => {
        if (response.data.status === 'success') {
          // console.log(response.data)
          this.ProgressListFriend = false
          this.listgroup = response.data.listgroup
        } else {
          this.ProgressListFriend = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    getlistchat () {
      // console.log(`bot listchat: ${process.env.VUE_APP_BOT_LISTCHAT}`)
      var api_listchat = ''
      if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
        api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
      } else {
        api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
      }
      // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v1/list-chat-pg'
      // api_listchat = process.env.VUE_APP_API_GOAPI + '/api/v5/getListChatForOfficial'
      this.ProgressListChat = true
      this.axios.post(api_listchat,
        { tokenuser: this.$route.params.id,
          chat_count: this.listchat_length,
          official_status: this.status_admin
        }).then((response) => {
        if (response.data.status === 'success') {
          this.ProgressListChat = false
          // console.log(response.data.listchat)
          // this.listchat = response.data['listchat']
          if (response.data.listchat.length === 20) {
            this.nextgetChat = true
          } else {
            this.nextgetChat = false
          }
          if (this.listchat !== null) {
            this.listchat = this.listchat.concat(response.data.listchat)
          } else {
            this.listchat = response.data.listchat
          }
          // console.log(this.listchat)
          this.listchat = _.unionBy(this.listchat, 'tokenroom')
          // console.log(this.listchat)
          // this.listchat_length = this.listchat.length
          // if (this.$route.params.id === process.env.VUE_APP_BOT_LISTCHAT) {
          //   this.listchat_length = this.listchat_length + 1
          // } else {
          //   this.listchat_length = this.listchat.length
          // }
          this.listchat_length = this.listchat_length + 1
          // console.log(response.data.listchat)
          // console.log(JSON.parse(localStorage.getItem('listchat')))
          localStorage.setItem('listchat', JSON.stringify(this.listchat))
          localStorage.setItem('listchat_length', response.data.listchat.length)
          // this.getnotcountread()
          var indexblock = []
          var indexmessage = []
          var indexactive = []
          indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
          indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
          indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
          var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
          var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
          var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
          var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
          this.num_countread = count - (countblock + countmsg + countactive)
          console.log(this.num_countread)
          if (this.num_countread !== 0) {
            this.showcountread = true
          } else {
            this.showcountread = false
          }
        } else {
          this.ProgressListChat = false
        }
      }).catch(err => {
        this.ProgressListChat = false
        console.log(err)
      })
    },
    getnotcountread () {
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getnotreadcount', {
        tokenuser: this.$route.params.id
      }).then((response) => {
        if (response.data.status === 'success') {
          console.log(response.data)
          if (response.data.count_read !== 0) {
            if (this.num_countread !== 0) {
              this.showcountread = true
            } else {
              this.showcountread = false
            }
          } else {
            this.showcountread = false
          }
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    routechat (data) {
      // console.log(data)
      this.actionF = data.tokenroom
      this.$router.push('/chat/' + this.$route.params.id + '/' + data.tokenroom)
      var indexmsg = _.findIndex(this.listchat, function (o) { return o.tokenroom === data.tokenroom })
      // console.log(indexmsg)
      this.listchat[indexmsg].is_active = 'true'
      this.listchat[indexmsg].count_read = 0
      this.mark_read(data)
      // console.log(this.listchat)
      localStorage.setItem('listchat', JSON.stringify(this.listchat))
      // this.listchat_length = this.listchat.length
      this.listchat_length = 0
      this.listchat = JSON.parse(localStorage.getItem('listchat'))
      var indexblock = []
      var indexmessage = []
      var indexactive = []
      indexmessage = _.filter(this.listchat, function (listchat) { return listchat.message === '' })
      indexblock = _.filter(this.listchat, function (listchat) { return listchat.state !== 'active' })
      indexactive = _.filter(this.listchat, function (listchat) { return listchat.is_active !== 'true' })
      var countmsg = _.sumBy(indexmessage, function (o) { return parseInt(o.count_read) })
      var countblock = _.sumBy(indexblock, function (o) { return parseInt(o.count_read) })
      var countactive = _.sumBy(indexactive, function (o) { return parseInt(o.count_read) })
      var count = _.sumBy(this.listchat, function (o) { return parseInt(o.count_read) })
      this.num_countread = count - (countblock + countmsg + countactive)
      if (this.num_countread !== 0) {
        this.showcountread = true
      } else {
        this.showcountread = false
      }
    },
    mark_read (data) {
      if (data.count_read !== '0' && data.count_read !== '') {
        this.axios.post(process.env.VUE_APP_API_ALPINE + '/api/v1/user-mark-read', { tokenuser: this.$route.params.id, tokenroom: data.tokenroom }).then((response) => {
        })
      }
    },
    toPage (data) {
      // console.log(data)
      this.$router.push(data + this.$route.params.id)
    },
    checkbotAutoreply () {
      // var body = {
      //   botid: this.$route.params.id
      // }
      this.axios.get(process.env.VUE_APP_API_CHECK_AUTOREPLY + '/checkactivebotautoreply/' + this.$route.params.id, {
        botid: this.$route.params.id
      }).then((response) => {
        if (response.data.message === 'success') {
          if (response.data.result.active === true) {
            // console.log(this.listsetting)
            var autorp = {
              title: 'ตอบกลับข้อความอัตโนมัติ',
              icon: 'fas fa-reply',
              dialog: '/account/settings/autoreply/'
            }
            this.listsetting.splice(4, 1, autorp)
          } else {
            this.listsetting.splice(4, 1)
          }
        }
      })
    }
  }
}
</script>
<style type="text/css" scoped>
.fontchat {
  color: gray;
  font-size: 12px;
}
.leftbox {
  height: calc(100vh - 64px);
  background-color: #fff !important;
  overflow: hidden;
}
>>>.v-input__slot {
  width: 100%;
  border-radius: 20px;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  border-radius: 20px !important;
  width: 100% !important;
  border-style: solid !important;
  border-color: #c1c1c1 !important;
  box-shadow: none !important;
  border-width: thin !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}

/* >>>.v-chip--small {
    height: 19px !important;
    width: 73px;
}

>>>.v-chip .v-chip__content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 28px;
    cursor: default;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    height: 32px;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    padding: 0 12px;
    vertical-align: middle;
    white-space: nowrap;
    z-index: 1;
    font-size: 18px;
} */

>>>.selectFilter{
  max-width: 200px;
  /* position: absolute;
  right: 0px;
  top: 16px; */
}
>>>.v-text-field.v-text-field--solo .v-input__control {
    min-height: 0px;
    padding: 0;
}
</style>
